import { IDocumentRequestOptions } from "./interfaces/document-request-options";
import { IDocumentModel } from "./interfaces/document-model";
import { autoinject } from "aurelia-dependency-injection";
import { DesktopView } from "../desktop/views/desktop";
import { DesktopModel } from "../desktop/models/desktop";
import { DocumentHolderModel } from "../desktop/models/document-holder";
import { MasterView } from "../shared/views/master-view";
import { AppEvents } from "../app-events";
import { AppSettings } from "../app-settings";
import { FullscreenReaderView } from "../desktop/views/fullscreen-reader";
import "print-this";
require("./styles/desktop.less");

@autoinject
export class DesktopModule extends Backbone.Model {

    private fullscreenRegion: Marionette.Region;

    constructor(private appEvents: Backbone.Events,
                private masterView: MasterView,
                public desktopModel: DesktopModel,
                private desktopView: DesktopView,
                private fullscreenView: FullscreenReaderView) {
            super();
            this.setupViews();
            this.setupEventListeners();
            this.setupDocumentIterator();
    }

    /** Hides the desktop */
    public hide(): void {
        $("#viewport-content").removeClass("desktop");
        $("#viewport-content").removeClass("desktop-ready");
    }

    public show() {
        this.slideDesktopIntoView();
        this.setPageTitle();
    }

    /** Requests that a document be displayed. If it is already loaded, go to it. If not, fetch it from the server
     * @param options An object containing options for this method
     */
    public requestDocument(options: IDocumentRequestOptions): void {
        this.show();
        this.desktopModel.requestDocument(options);
    }

    public enterDesktopFromPrecedentMap(options: IDocumentRequestOptions): void {
        $("body").removeClass("precedent-map");
        $("header").show();
        $("#desktop-region").css({ zIndex: -8 });
        this.show();
        this.desktopModel.enterDesktopFromPrecedentMap(options);
    }

    public hideFullscreenReader() {
        $(".print-controls").off();
        this.fullscreenRegion.empty({preventDestroy: true});
        $(this.fullscreenRegion.el).hide();
    }

    /** Removes every DocumentHolder from the desktop */
    public removeAllDocumentHolders(): void {
        this.desktopModel.clear();
    }

    public prepareDesktopForPrecedentMap(id: string): Promise<IDocumentModel> {
        $("body").addClass("precedent-map");
        $("header").hide();
        return this.desktopModel.enterPrecedentMap(id);
    }

    public printFullText(docId: string, fromReader: boolean): void {
        let $el: JQuery;
        if (fromReader) {
            $el = $(this.fullscreenRegion.el);
        } else {
            $el = this.desktopView.$el.find(".document-holder").children(":visible");
        }
        const contentToPrint = $el.find("[data-full-text-id=" + docId + "]");
        contentToPrint.show();
        contentToPrint.printThis({
            importCSS: false,
            removeScripts: true,
            loadCSS: "assets\\css\\print.css",
            printDelay: 500
        });
    }

    public showFullscreenReader(content: JQuery) {
        const self = this;
        this.fullscreenRegion.show(this.fullscreenView);
        const $el = $(this.fullscreenRegion.el);
        $el.fadeIn("fast", () => {
            content.prepend(`<div class="full-text-content-toolbar"></div>`);
            let contentToShow = this.addPrintControlsToContent(content);
            contentToShow = this.addCloseButtonToContent(contentToShow);
            $el.find("#fullscreen-reader").append(contentToShow);

            $(".print-controls").click((e) => {
                const docId = $(e.currentTarget).children(".print-fulltext-button").attr("id");
                this.appEvents.trigger(AppEvents.PrintFullText, docId, true);
            });

            $(".close-reader").click(() => {
                self.hideFullscreenReader();
            });
        });
    }

    private addPrintControlsToContent(content: JQuery): JQuery {
        const isPdfMode = content.find(".full-text-content").hasClass("pdf-mode");
        if (isPdfMode) {
            return content;
        }
        const contentId = content.find(".full-text-document").attr("data-full-text-id");
        const activeDoc = this.desktopView.$el.find(".document-holder").children(":visible");
        if (activeDoc.find(".print-fulltext-button").is(":visible")) {
            const printControls = activeDoc.find("#" + contentId + ".print-fulltext-button").parent().clone();
            content.find("[class*=full-text-content-toolbar]").prepend(printControls);
        }
        return content;
    }

    private addCloseButtonToContent(content: JQuery): JQuery {
        const closeButton = `<div class="btn-group close-reader"><button class="btn"><i class="fa fa-remove"></i></button></div>`;
        if (content.find("[class*=full-text-content-toolbar]").length > 0) {
            content.find("[class*=full-text-content-toolbar]").prepend(closeButton);
        } else {
            content.find("[class*=report-holder-toolbar]").prepend(closeButton);
        }
        return content;
    }

    /** Removes the passed in DocumentHolder from the desktop
     * @param model The DocumentHolder to be removed
     */
    private removeDocumentHolder(model: DocumentHolderModel): void {
        this.desktopModel.removeDocumentHolder(model);
    }

    private setupViews() {
        this.listenToOnce(this.masterView, "render", () => {
            const desktopRegion = this.masterView.addRegion("desktopRegion", "#desktop-region");
            this.fullscreenRegion = this.masterView.addRegion("fullscreenReaderRegion", "#fullscreen-reader-region");
            desktopRegion.show(this.desktopView);
        });
    }

    private slideDesktopIntoView() {
        if (!$("#viewport-content").hasClass("desktop")) {
            $("#viewport-content").addClass("desktop");
            setTimeout(() => {
                $("#viewport-content").addClass("desktop-ready");
            }, 820);
        } else {
            $("#viewport-content").addClass("desktop-ready");
        }

    }

    private setPageTitle() {
        if (this.desktopModel.Focus && this.desktopModel.Focus.TargetModel) {
            const title = this.desktopModel.Focus.TargetModel.Title;
            if (title !== null) {
                document.title = title + " on JustisOne";
            }
        }
    }

    private setupEventListeners(): void {
        this.appEvents.on(AppEvents.DocumentHolderClosed, (model) => {
            this.removeDocumentHolder(model);
        });

        this.appEvents.on(AppEvents.DesktopMode, (multiple: boolean) => {
            this.desktopModel.MultipleMode = multiple;
        });

        this.appEvents.on(AppEvents.PrintFullText, (docId: string, fromReader: boolean) => {
            this.printFullText(docId, fromReader);
        });
    }

    private moveToDocument(direction: string) {
        if (this.desktopModel.Focus) {
            const current = this.desktopModel.Focus.TargetModel;
            if (current.Populated || current.Error) {
                const id = current.Id;
                this.desktopModel.clear();
                $.get(`${AppSettings.DocumentApiUrlPrefix}document/${direction}/${id}`).done((url) => {
                    Backbone.history.navigate(url, {trigger: true});
                });
            }
        }
    }

    private setupDocumentIterator() {
        $(document).keyup((e: JQueryKeyEventObject) => {
            if (!e.altKey) {
                return;
            }
            if (e.keyCode === 102) {
                this.moveToDocument("next");
            } else if (e.keyCode === 100) {
                this.moveToDocument("prev");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/desktop-module.ts